import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import SlidingPane from "react-sliding-pane";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { API } from '../../backend';
import Form from "react-validation/build/form";
import { getTrans as t } from "../../Localization/translations"
import Select from 'react-select';
import ButtonLoading from '../Loder/buttonLoading';
import CheckButton from "react-validation/build/button";
import GetNotesService from '../../services/notes/notes';
import { toast } from 'react-toastify';
import axios from 'axios';
import authHeader from '../../services/auth-header';


const NotesAll = ({
  setIsSidePanelOpen,
  setSelectedValue,
  setOptions2,
  setState,
  isSidePanelOpen,
  options2,
  selectedValue,
  state
}) => {
  const [allTags, setAllTags] = useState([]);
  
  const [isLoading2, setIsLoading2] = useState(false);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [select, setSelect] = useState("");
  const [isLoadingVal, setIsLoadingVal] = useState(false)
  const [inputvalue, setInputNoteValue] = useState("");
  const [inputValue, setInputValue] = useState('');


    const form5 = useRef();
    const checkBtn5 = useRef();
    const {
      register,
      handleSubmit: handleSubmit5,
      reset: reset5,
      formState: { errors: errors5 },
    } = useForm();


    const handleAddNotes = () => {
        form5.current.validateAll();
        setIsLoadingVal(true)
        const getuserid = localStorage.getItem('userid')
        if (checkBtn5.current.context._errors.length === 0) {
          GetNotesService.createNotes(state, select, inputValue, getuserid)
            .then((res) => {
              if (res.data.success === 1) {
                toast.success(`${res.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                })
                setInputValue('')
                setSelectedValue('')
                setSelect('')
                setInputNoteValue('')
                setIsLoadingVal(false)
                reset5({
                  selectType: '',
                  selectValue: '',
                  note: ''
                })
                setTimeout(() => {
                  setIsSidePanelOpen(false)
                }, 3000);
              } else {
                toast.error(`${res.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                })
                setInputValue('')
                setSelectedValue('')
                setSelect('')
                setInputNoteValue('')
                setIsLoadingVal(false)
              }
            })
        }
        setIsLoadingVal(false)
      }

    
      // const handleInputNoteChange = (e) => {
      //   const value = e.target.value;
      //   setInputValue(value);
      
      //   if (value.endsWith(" ") && value) {
      //     const newTag = value;
      //     setSelectedTags([...selectedTags, newTag]);
      //   }
      // };
    
      const handleTagClick = (tag) => {
        setInputValue(inputValue + tag);
      };
    
      const handelOnChange = (e) => {
        setInputNoteValue('')
        setSelectedValue('')
        setOptions2([])
        setSelect(e.target.value);
      };
    
      const handelInputNotChange = (value) => {
        setInputNoteValue(value);
        setCurrentPage2(1);
        setOptions2([]);
        loadOptions(value, 1);
      };

      const handleMenuScrollToBottomName = () => {
        loadOptions(inputvalue, currentPage2);
      };
    
      const handelChange = (value) => {
        setState('')
        setSelectedValue(value);
        setState(value.id)
        reset5(
          { selectValue: value }
        )
      };

      const loadOptions = async (value, page) => {
        try {
          if (select !== '') {
            if (select === 'Parties') {
              setIsLoading2(true);
              const response = await fetch(`${API}parties/party/?customer_name=${value}&page=${page}`, { headers: authHeader() });
              const newData = await response.json();
    
              if (newData && newData.data && newData.data.length > 0) {
                const newOptions = newData.data
    
                setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
                setCurrentPage2((prevPage) => prevPage + 1);
              }
            } else if (select === 'Contract') {
              let url = API + "contracts/contracts/0/?";
              url += "page=" + page;
              url += "&search=" + '';
              url += '&contractNumber=';
              url += `&customerName=`;
              const response = await fetch(url, { headers: authHeader() })
              const newData = await response.json();
              if (newData && newData.data && newData.data.length > 0) {
                const newOptions = newData.data
    
                setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
                setCurrentPage2((prevPage) => prevPage + 1);
              }
            } else if (select === 'Invoice') {
              let url = API + "billing/invoices/?"
              url += 'page=' + page
              url += '&search='
              url += `&contractNumber=`
              url += `&customerName=`
              url += `&contractid=undefined`
              const response = await fetch(url, { headers: authHeader() })
              const newData = await response.json();
              if (newData && newData.data && newData.data.length > 0) {
                const newOptions = newData.data
    
                setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
                setCurrentPage2((prevPage) => prevPage + 1);
              }
              else {
                console.error('No data received or empty array from API.');
              }
              setIsLoading2(false);
            }
            else if (select === 'Receipts') {
              let url = API + "receipts/view/receipts/?"
              url += 'page=' + page
              url += '&search='
              url += `&contractNumber=`
              url += `&customerName=`
              const response = await fetch(url, { headers: authHeader() })
              const newData = await response.json();
              if (newData && newData.data && newData.data.length > 0) {
                const newOptions = newData.data
    
                setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
                setCurrentPage2((prevPage) => prevPage + 1);
              }
              else {
                console.error('No data received or empty array from API.');
              }
              setIsLoading2(false);
            }
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          setIsLoading2(false);
        }
      };

      useEffect(() => {
        if (select !== '') {
          loadOptions('%', 1)
        }
      }, [select])

      useEffect(() => {
        if(select !== ''){
          axios.get(API + `helper/notecontextfilter-view/?object_name=${select}`, { headers: authHeader(), })
            .then((res) => {
              setAllTags(res.data.response);
            })
        }
      }, [select]);  

      const handleEditorChange = (event, editor) => {
        const data = editor.getData();
        setInputValue(data);
      };

  return (
    <div>
    {isSidePanelOpen &&
      <SlidingPane
        className="some-custom-class sidepanebar"
        isOpen={isSidePanelOpen}
        title="Add Notes"
        subtitle=""
        onRequestClose={() => {
          setIsSidePanelOpen(false);
          setInputNoteValue('')
          setSelectedValue('')
          setOptions2([])
          setState('')
        }}
      >
        <Form
          role='form text-left'
          onSubmit={handleSubmit5(handleAddNotes)}
          ref={form5}
          key={5}
          action="."
          method="POST"
          id="addNoteForm">
          <div className="col-md-6">
            <div>
              <span className="mb-0 tc required">{t("Select")}</span>
              <select
                className="form-control col-md-6 form-select  mb-1"
                {...register("selectType", { required: true })}
                value={select}
                name="selectType"
                onChange={handelOnChange}
              >
                <option value="">{t("Select ")}</option>
                <option value="Parties">{t("Party")}</option>
                <option value="Contract">{t("Contract")}</option>
                <option value="Invoice">{t("Invoice")}</option>
                <option value="Receipts">{t("Receipt")}</option>
              </select>
              <div className="invalid-feedback">
                {errors5.selectType?.type === "required" && "Select Type is required"}
              </div>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {`${select}`}
              </label>
              <div className="col-lg-12">
                <Select
                  {...register("selectValue", { required: true })}
                  value={selectedValue}
                  filterOption={false}
                  options={options2}
                  defaultValue={options2}
                  isClearable
                  name="selectValue"
                  onInputChange={handelInputNotChange}
                  getOptionLabel={(options) => select === 'Contract' ? options.contract_number : select === 'Invoice' ? options.invoice_number : select === 'Receipts' ? options.receipt_number : options.customer_name}
                  getOptionValue={(options) => select === 'Contract' ? options.contract_number : select === 'Invoice' ? options.invoice_number : select === 'Receipts' ? options.receipt_number : options.customer_name}
                  isLoading={isLoading2}
                  placeholder={`Search for ${select}(%for All)`}
                  onMenuScrollToBottom={handleMenuScrollToBottomName}
                  onChange={handelChange}
                />
                <div className="invalid-feedback">
                  {errors5.selectValue?.type === "required" && "Select Value is required"}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="row align-items-center">
              <div className="col-lg-9">
                {/* <input
                  {...register("note", { required: true })}
                  placeholder={t("Enter Note")}
                  className="form-control"
                  type="text"
                  name="note"
                  id="id_note"
                  value={inputValue}
                  onChange={handleInputNoteChange}
                /> */}
                  <CKEditor
                    editor={ClassicEditor}
                    data={inputValue}
                    onChange={handleEditorChange}
                     onFocus={false}
                    data-cke-filler={false}
                    config={{
                      licenseKey: '',  // ✅ blank string, not 'GPL'

                      toolbar: [
                         'undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikethrough', '|',
                        'bulletedList', 'numberedList', 'link', '|',
                        'heading', 'blockQuote', 'codeBlock'
                      ],
                      heading: {
                        options: [
                          { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                          { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                          { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                          { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
                        ]
                      }
                    }}

                  />
              </div>
              <div className="invalid-feedback">
                {errors5.note?.type === "required" && "Note is required"}
              </div>
              <div className="col-lg-3">
                <button type="submit"
                  className="btn btn-primary" style={{ marginTop: '13px' }}
                >
                  {
                    isLoadingVal ?
                      <ButtonLoading /> : 'Add Note'

                  }
                </button>
              </div>
              <CheckButton style={{ display: "none" }} ref={checkBtn5} />

            </div>
            {allTags && allTags.length > 0 && (
            <div style={{ marginTop: '10px' }}>
              {allTags.map((tag, index) => (
                <React.Fragment key={index}>
                  {index > 0 && <span style={{ margin: '0 5px' }}>&bull;</span>}
                  <span
                    style={{
                      backgroundColor: '#f0f0f0',
                      padding: '5px 10px',
                      borderRadius: '20px',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleTagClick(tag.context_value)}
                  >
                    {tag.context_value}
                  </span>
                </React.Fragment>
              ))}
            </div>
            )}
          </div>
        </Form>
      </SlidingPane>
    }

  </div>
  )
}

export default NotesAll